import {createAction} from 'redux-act';

export const GET_BAD_ORDER = createAction('orderDetails/GET_BAD_ORDER');
export const GET_BAD_ORDER_SUCCESS = createAction(
  'orderDetails/GET_BAD_ORDER_SUCCESS'
);
export const RUN_BAD_ORDER_DETAIL_JOB = createAction(
  'orderDetails/RUN_BAD_ORDER_DETAIL_JOB'
);
export const STOP_BAD_ORDER_DETAIL_JOB = createAction(
  'orderDetails/STOP_BAD_ORDER_DETAIL_JOB'
);
export const SET_BAD_ORDER_DETAIL_NOTES = createAction(
  'orderDetails/SET_BAD_ORDER_DETAIL_NOTES'
);
export const SET_BAD_LARGE_ORDER_STATUS = createAction(
  'orderDetails/SET_BAD_LARGE_ORDER_STATUS'
);
export const CLEAR_BAD_ORDER = createAction('orderDetails/CLEAR_BAD_ORDER');

export const SET_BAD_ORDER_DETAIL_LOADING = createAction(
  'orderDetails/SET_BAD_ORDER_DETAIL_LOADING'
);

export const UPDATE_BAD_STATUS = createAction('orderDetails/UPDATE_BAD_STATUS');

export const RATE_BAD_DRIVER = createAction('orderDetails/RATE_BAD_DRIVER');
export const RATE_BAD_DRIVER_SUCCESS = createAction(
  'orderDetails/RATE_BAD_DRIVER_SUCCESS'
);
export const RATE_BAD_DRIVER_ERROR = createAction(
  'orderDetails/RATE_BAD_DRIVER_ERROR'
);
export const GET_BAD_DRIVER_RATING = createAction(
  'orderDetails/GET_BAD_DRIVER_RATING'
);
export const GET_BAD_DRIVER_RATING_SUCCESS = createAction(
  'orderDetails/GET_BAD_DRIVER_RATING_SUCCESS'
);
export const GET_BAD_DRIVER_RATING_ERROR = createAction(
  'orderDetails/GET_BAD_DRIVER_RATING_ERROR'
);
export const UPDATE_BAD_DRIVER_RATING = createAction(
  'orderDetails/UPDATE_BAD_DRIVER_RATING'
);
export const UPDATE_BAD_DRIVER_RATING_SUCCESS = createAction(
  'orderDetails/UPDATE_BAD_DRIVER_RATING_SUCCESS'
);
export const UPDATE_BAD_DRIVER_RATING_ERROR = createAction(
  'orderDetails/UPDATE_BAD_DRIVER_RATING_ERROR'
);
export const DELETE_BAD_DRIVER_RATING = createAction(
  'orderDetails/DELETE_BAD_DRIVER_RATING'
);
export const DELETE_BAD_DRIVER_RATING_SUCCESS = createAction(
  'orderDetails/DELETE_BAD_DRIVER_RATING_SUCCESS'
);
export const DELETE_BAD_DRIVER_RATING_ERROR = createAction(
  'orderDetails/DELETE_BAD_DRIVER_RATING_ERROR'
);
